import React from "react";
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import '../css/lesson.css';
import View from '../../../Admin/Lessons/View';
import { fetchLesson } from '../../../Admin/Lessons/actions/';
import Loading from "../../../Loading/";
import { startExam, saveExamAnswer } from '../../../Admin/Exams/actions';
import ShowQuestionModal from "../ExamView/ShowQuestionModal";
import QuestionView from '../../../Admin/Question/View/QuestionView';
import api from "../../../../api/api";
import history from '../../../../history';
import LessonResult from './LessonResult';
import LessonFinish from './LessonFinish';
import { studentLiveObserver } from '../../../../../realtime/services/StudentLiveObserver';

class LessonView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            FontSize: 18,
            showSound: false,
            showEndPage: false,
            showResult: false,
            showEnd: false,
            showQuestionModal: false,
            isTimeFinish: false,
            styleQuestion: '',
            styleBind: '',
            styleText: '',

            Id: 0,
            Name: '',
            Bio: '',
            Sort: 0,
            Sound: '',
            Url: '',
            Icon: '',
            Background: '',
            Questions: [],
            IsActive: true,
            IsPublic: false,
            IndexId: 0,
            questionSeparated: {
                BorderStyle: "dashed",
                BorderColor: 'rgba(68, 68, 68, 1)',
                BorderWidth: 3,
                width: 100
            }
        };
        this._toastId = new React.createRef();
        this.yourTime = 0;
        this.props.startExam();
    }

    showSound = showSound => {
        this.setState({ showSound });
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        this.setState({
            Id: id
        });
        if (id !== '0') {
            this.props.fetchLesson(id, true);
        }

        setInterval(() => {
            this.yourTime += 1;
        }, 1000);
    }

    static getDerivedStateFromProps(props, state) {
        const { id } = props.match.params;
        if (props.lessons && state.Id && state.Id !== '0') {
            if (props.lessons && props.lessons.code && props.lessons.code === "no_permission") {
                history.push(`/NoPermissions/`);
            }
            if (!state.showPagesModal && !state.showLessonInfoModal && props.lessons.current) {
                let lesson = props.lessons.current;

                let FontSize = 18;
                let questionSeparated = state.questionSeparated;
                if (lesson.CustomStyle) {
                    if (lesson.CustomStyle.FontSize) {
                        FontSize = lesson.CustomStyle.FontSize;
                    }
                    if (lesson.CustomStyle.questionSeparated) {
                        questionSeparated = lesson.CustomStyle.questionSeparated;
                    }
                }

                let LessonPage = [];
                if (lesson.LessonPage) {
                    let toRemove = props.lessons.PageToRemove;
                    lesson.LessonPage.sort((a, b) => a.Sort - b.Sort).forEach(item => {
                        if (!toRemove || !toRemove.includes(item.Id)) {
                            LessonPage = [...LessonPage, item];
                        }
                    });
                }

                let obj = {
                    Sort: lesson.Sort,
                    Id: lesson.Id,
                    Name: lesson.Name,
                    Bio: lesson.Bio,
                    Background: lesson.Background,
                    Sound: lesson.Sound,
                    IsActive: lesson.IsActive,
                    IsPublic: lesson.IsPublic,
                    IndexId: lesson.Index ? lesson.Index.Id : state.IndexId,
                    Icon: lesson.Icon,
                    Url: lesson.Url,
                    LessonPage: LessonPage,
                    Questions: lesson.Questions ? lesson.Questions.sort((a, b) => a.Sort - b.Sort) : [],
                    FontSize,
                    questionSeparated
                    //        first: false,
                };

                if (obj.Questions) {
                    var hasRight = obj.Questions.some(p => p.Position === true);
                    var hasLeft = obj.Questions.some(p => p.Position === false);
                    if (hasRight && !hasLeft) {
                        obj = {
                            ...obj,
                            styleQuestion: {
                                style: {
                                    display: 'none'
                                }
                            },
                            styleBind: {
                                style: {
                                    display: 'none'
                                }
                            },
                            styleText: {
                                style: {
                                    width: '100%'
                                }
                            }
                        };
                    } else if (!hasRight && hasLeft) {
                        obj = {
                            ...obj,
                            styleQuestion: {
                                style: {
                                    width: '100%'
                                }
                            },
                            styleBind: {
                                style: {
                                    display: 'none'
                                }
                            },
                            styleText: {
                                style: {
                                    display: 'none'
                                }
                            }
                        };
                    } else {
                        obj = {
                            ...obj,
                            styleQuestion: {},
                            styleBind: {},
                            styleText: {}
                        };
                    }
                }

                return obj;
            } else if (props.lessons.current) {
                let lesson = props.lessons.current;
                state.Questions = lesson.Questions ? lesson.Questions.sort((a, b) => a.Sort - b.Sort) : [];

                let LessonPage = [];
                if (lesson.LessonPage) {
                    let toRemove = props.lessons.PageToRemove;
                    lesson.LessonPage.sort((a, b) => a.Sort - b.Sort).forEach(item => {
                        if (!toRemove || !toRemove.includes(item.Id)) {
                            LessonPage = [...LessonPage, item];
                        }
                    });
                }
                state.LessonPage = LessonPage;

                if (lesson.CustomStyle) {
                    if (lesson.CustomStyle.questionSeparated) {
                        state.questionSeparated = lesson.CustomStyle.questionSeparated;
                    }
                }

                if (lesson.Questions && lesson.Questions.length !== 0) {
                    var hasRights = lesson.Questions.some(p => p.Position === true);
                    var hasLefts = lesson.Questions.some(p => p.Position === false);
                    if (hasRights && !hasLefts) {
                        state = {
                            ...state,
                            styleQuestion: {
                                style: {
                                    display: 'none'
                                }
                            },
                            styleBind: {
                                style: {
                                    display: 'none'
                                }
                            },
                            styleText: {
                                style: {
                                    width: '100%'
                                }
                            }
                        };
                    } else if (!hasRights && hasLefts) {
                        state = {
                            ...state,
                            styleQuestion: {
                                style: {
                                    width: '100%'
                                }
                            },
                            styleBind: {
                                style: {
                                    display: 'none'
                                }
                            },
                            styleText: {
                                style: {
                                    display: 'none'
                                }
                            }
                        };
                    } else {
                        state = {
                            ...state,
                            styleQuestion: {},
                            styleBind: {},
                            styleText: {}
                        };
                    }
                }

            }
        }
        state.Id = id;
        return state;
    }


    sumTotalQuestions() {
        let sum = 0;
        this.props.exam.marks.forEach(item => {
            sum += item.userMark;
        })
        return sum.toFixed(2);
    }

    showFinish = () => {
        if (!this.state.showEndPage) {
            var QuestionsCount = this.state.Questions.filter(p => p.Type.Id !== 11).length;
            var AnswerCount = this.props.exam.current.length;
            if (QuestionsCount !== AnswerCount) {
                const { t } = this.props;
                this._toastId.current = toast(t('Processing'), {
                    position: "bottom-left",
                    autoClose: false
                });
                toast.update(this._toastId.current, {
                    render: () => <div>
                        <div className="h5"> <i className="icon fal fa-engine-warning"></i> {t('Pages.Lessons.toast.Warning.Title')}</div>
                        <div className="h6">{t('Pages.Lessons.toast.Warning.Body')}</div>
                    </div>,
                    type: toast.TYPE.WARNING,
                    position: "bottom-left",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
        this.setState({
            showEndPage: !this.state.showEndPage
        });
    }

    openQuestion = id => {
        const question = this.state.Questions.filter(p => p.Id === id)[0];
        if (question) {
            this.setState({
                showQuestionModal: true,
                showResult: false,
                question
            });
        }
    }

    renderFinish = () => {
        return (
            <LessonFinish
                isOpen={this.state.showEndPage}
                lessonName={this.state.Name}
                questions={this.state.Questions}
                exam={this.props.exam}
                onClose={() => this.showFinish()}
                onFinish={() => this.showEnd()}
                onOpenQuestion={this.openQuestion}
            />
        );
    }

    showEnd = () => {
        this.setState({
            showEnd: true,
            showEndPage: false,
            yourTime: this.yourTime
        }, () => {
            studentLiveObserver.triggerSnapshot(300);
        });

        const { exam, t } = this.props;

        let _toastId = toast(t('Processing'), {
            position: "bottom-left",
            autoClose: false
        });
        toast.update(_toastId, {
            render: () => <div> <i className="fa-spin fas fa-spinner"></i> {t('Processing')} </div>,
            autoClose: false,
            closeOnClick: false,
        });

        const seconds = Math.floor(this.yourTime % 60);
        const minutes = Math.floor((this.yourTime / 60) % 60);
        const hour = Math.floor(this.yourTime / 3600);

        api.post(`/UserLessonMark/${this.state.Id}`,
            {
                answers: exam.current,
                total: this.sumTotalQuestions(),
                CustomeStyle: {
                    Clock: {
                        seconds,
                        minutes,
                        hour
                    }
                }
            }
        ).then(response => {
            toast.update(_toastId, {
                render: () => <div>
                    <div className="h5">
                        <i className="icon fal fa-shield-check"></i>
                        {t('Pages.Lessons.save_toast.Title')}
                    </div>
                    <div className="h6">
                        {t('Pages.Lessons.save_toast.Body')}
                    </div>
                </div>,
                type: toast.TYPE.INFO,
                position: "bottom-left",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        }).catch(error => {
            toast.update(_toastId, {
                render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                type: toast.TYPE.ERROR,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });

        setTimeout(() => {
            window.scrollToTop();
        }, 200);
    }

    renderEnd = () => {
        if (this.state.showEnd) {
            return (
                <LessonResult
                    lesson={this.props.lessons?.current || {}}
                    lessonId={this.state.Id}
                    lessonTitle={this.state.Name}
                    lessonIndexId={this.state.IndexId}
                    questions={this.state.Questions}
                    exam={this.props.exam}
                    user={this.props.user}
                    elapsedSeconds={this.state.yourTime}
                    isTimeFinish={this.state.isTimeFinish}
                    isMission={this.props.isMission}
                    fontSize={this.state.FontSize}
                    onReset={this.resetExam}
                    onOpenQuestion={this.openQuestionResult}
                />
            );
        }
        return "";
    }

    openQuestionResult = questionOrId => {
        const question = typeof questionOrId === 'object' && questionOrId !== null
            ? questionOrId
            : this.state.Questions.find(p => p.Id === questionOrId);
        if (question) {
            this.setState({
                showQuestionModal: true,
                showResult: true,
                question
            });
        }
    }

    resetExam = () => {
        window.location.reload(false);
    }

    handleClose = () => {
        setTimeout(() => {
            this.setState({
                showQuestionModal: false
            });
        }, 450);
    }

    saveExamAnswer = (id, typeId, answers, mark, userMark) => {
        this.props.saveExamAnswer(id, typeId, answers, mark, parseFloat(userMark));
    }

    renderQuestionView = () => {
        const question = this.state.question;
        const { exam } = this.props;
        const isSolving = !this.state.showResult;
        if (this.state.question) {
            return <QuestionView
                question={question}
                answers={question.Answers}
                key={question.Id}
                index={1}
                indexType={1}
                showResult={this.state.showResult}
                onEdit={false}
                solveButton={isSolving}
                isExamQuestion={false}
                saveExamAnswer={this.saveExamAnswer}
                examAnswers={exam.current}
                FontSize={this.state.FontSize} />
        }
        return "";
    }

    render() {
        const { t, lessons, exam } = this.props;
        if ((lessons.length === 0 || !lessons.current) && this.state.Id !== '0') {
            return <Loading></Loading>
        }
        return (
            <>
                {
                    this.state.showQuestionModal ?
                        <ShowQuestionModal
                            renderQuestionView={this.renderQuestionView}
                            showResult={this.state.showResult}
                            handleClose={this.handleClose} />
                        : ""
                }
                {
                    !this.state.showSound ?
                        <style dangerouslySetInnerHTML={{ __html: `html{width: calc(100% - 15px);overflow-x: unset;}header{ display:none; }body{overflow-x: hidden;}section{padding-top:5px !important;padding-bottom:5px !important;}` }}></style>
                        :
                        <style dangerouslySetInnerHTML={{ __html: `html{width: calc(100% - 15px);overflow-x: unset;}header{ display:none; }body{overflow-x: hidden;}section{padding-top:5px !important;}` }}></style>
                }
                {
                    this.state.showEndPage || this.state.showEnd ? "" :
                        <>
                            <View
                                showSound={this.showSound}
                                IndexId={this.state.IndexId}
                                key={this.state.Id}
                                Id={this.state.Id}
                                Name={this.state.Name}
                                isRated={lessons && lessons.current ? lessons.current.isRated : false}
                                Sound={this.state.Sound}
                                Url={this.state.Url}
                                Questions={this.state.Questions}
                                LessonPage={this.state.LessonPage}
                                questionSeparated={this.state.questionSeparated}
                                QuestionToRemove={[]}
                                FontSize={this.state.FontSize}
                                Background={this.state.Background}
                                isOnEdit={false}
                                examAnswers={exam.current}
                                saveExamAnswer={this.saveExamAnswer}
                            />
                            {
                                lessons && lessons.current && lessons.current.Questions && lessons.current.Questions.some(p => p.Type.Id !== 11) ?
                                    <div className="d-flex justify-content-center">
                                        <div onClick={() => this.showFinish()} className="theme-btn btn-style-two d-inline-flex mb-1">
                                            <span className="txt pl-2"> {t('Pages.Lessons.showEnd')} </span>
                                            <div className="mouse-btn-down">
                                                <div className="chevron"></div>
                                                <div className="chevron"></div>
                                                <div className="chevron"></div>
                                            </div>
                                        </div>
                                    </div>
                                    : ""
                            }

                        </>
                }

                {this.renderFinish()}
                {this.renderEnd()}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        lessons: state.lessons,
        exam: state.exam,
        user: state.user
    };
};

export default connect(mapStateToProps, { fetchLesson, startExam, saveExamAnswer })(withTranslation('common')(LessonView));